import { useEffect, useState } from 'react';

function useGeneratedImages() {
  const [generatedImages, setGeneratedImages] = useState<any>(null);

  useEffect(() => {
    const imagesFromLocalStorage = localStorage.getItem('generate_images');
    if (imagesFromLocalStorage) {
      setGeneratedImages(imagesFromLocalStorage);
    } else {
      setGeneratedImages(false);
    }
  }, []);

  return generatedImages;
}

export default useGeneratedImages;
